import { NgModule } from '@angular/core';
import { InputTrimDirective } from './input-trim.directive';
import { InputFilterDirective } from './input-filter.directive';
import { AutofocusDirective } from './autofocus.directive';
import { AutoScrollTargetInputDirective } from './auto-scroll-target-input.directive';
import { CapitalizeWithDashDirective } from './capitalize-with-dash.directive';
import { NumberDirective } from './number.directive';
import { PhoneInputDirective } from './phone-input.directive';
import { IntinputDirective } from './intinput.directive';
import { InternationalPhoneInputDirective } from './international-phone-input.directive';

@NgModule({
  declarations: [
    InputTrimDirective,
    InputFilterDirective,
    AutofocusDirective,
    AutoScrollTargetInputDirective,
    CapitalizeWithDashDirective,
    NumberDirective,
    PhoneInputDirective,
    IntinputDirective,
    InternationalPhoneInputDirective,
  ],
  exports: [
    InputTrimDirective,
    InputFilterDirective,
    AutofocusDirective,
    AutoScrollTargetInputDirective,
    CapitalizeWithDashDirective,
    NumberDirective,
    PhoneInputDirective,
    IntinputDirective,
    InternationalPhoneInputDirective,
  ],
})
export class DirectivesModule {}
